/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { ROUTE_PATHS } from '../constants';
import { useNavigate } from 'react-router-dom';
import { selectCurrentUser, selectIsAuthenticated } from '../../layouts/AdminLayout/slice/selectors';
import { useSelector } from 'react-redux';
import { clearAuthToken } from '../../helpers/request';
import { ROLES } from '../../layouts/MainLayout/slice/constants';

interface AdminGuardProps {
  children: React.ReactNode;
}
export default function AdminGuard({ children }: AdminGuardProps): React.ReactElement {
  const navigate = useNavigate();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const currentUser = useSelector(selectCurrentUser)
  useEffect(() => {
    const accessToken = localStorage.getItem(`token-${process.env.REACT_APP_PUBLIC_URL}`);
    if (!accessToken) {
      navigate(ROUTE_PATHS.LOGIN);
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      clearAuthToken();
      navigate(ROUTE_PATHS.LOGIN);
    }
  }, [isAuthenticated]);

  useEffect(()=>{
    if (currentUser && currentUser.role !== ROLES.ADMIN) {

      navigate(ROUTE_PATHS.PORTAL);
    }
  },[currentUser])

  return <>{children}</>;
}
